var render, staticRenderFns
import script from "./CommercialPolicyMixin.vue?vue&type=script&lang=js&"
export * from "./CommercialPolicyMixin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce9a5a82",
  null
  
)

export default component.exports